import { useMutation, useQueryClient } from 'react-query';
import { invalidatePlannerTasks } from './invalidatePlannerTasks';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { deletePlannerTask } from 'RestAPIs/planner-messages';
import { PlannerMessage } from '../types';

const useDeletePlannerTask = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isSuccess } = useMutation(
    (processInstanceId: string) => deletePlannerTask(processInstanceId),
    {
      onSuccess: (_data, processInstanceId) => {
        // Drop the deleted row from the cached page right away: keepPreviousData
        // keeps it on screen until the refetch lands, and DataGrid virtualisation
        // can remount the delete button in that window - resetting its isSuccess
        // guard and allowing a second DELETE.
        queryClient.setQueriesData<[PlannerMessage[], number] | undefined>(
          'plannerTasks',
          (previous) =>
            previous
              ? [
                  previous[0].filter(
                    (m) => m.processInstanceId !== processInstanceId
                  ),
                  Math.max(previous[1] - 1, 0)
                ]
              : previous
        );

        showSuccessSnackbar();
        invalidatePlannerTasks(queryClient);
      },
      onError: () => showErrorSnackbar()
    }
  );

  // Call this once per row (see DeleteTaskButton): react-query v3 exposes the
  // state of a single observer, so a shared instance would report the last
  // mutation's status for every row.
  return { mutateAsync, isLoading, isSuccess };
};

export default useDeletePlannerTask;
